const hy = {
  copyLink: 'Պատճենել URL-ը',
  copied: 'Պատճենված է',
  share: 'Կիսվել',
  description: 'Նկարագրություն',
  hrText: 'ՄՌԿ (HR)',
  productText: 'Պրոդուկտ',
  usage: 'Կիրառության օրինակներ',
  mentionedIn: 'Այս հակումը պատասխանում է հետևյալ հարցերին',
  productValue: 'Product value',
  usageUiUx: 'Example of use by UI/UX',
  usageHr: 'Example of use by HR',
  managementValue: 'Management value',
  answersLabel: 'Հնարավոր պատասխաններ',
  relatedQuestionsLabel: 'Առնչվող հարցեր',
  uxeducationButtonLabel: 'Using UXCG in Education',
  downloadButtonLabel: 'Ներբեռնել PDF', //TODO Add to sheet
  visualExample: 'Տեսողական օրինակ',
  offsecText: 'Offensive Cybersecurity',
  offsecShortText: 'OffSec',
  usageOffsec: 'Example of use by Offensive Cybersecurity',
  offsecComingSoon:
    'Offensive Cybersecurity use cases — coming soon. We are curating attacker-side and defender-side scenarios for every bias in UX Core.',
  nextLabel: 'Հաջորդը',
  prevLabel: 'Նախորդը',
};
export default hy;
